export default "__VITE_ASSET__PWd8aapBt1YfLvgRaedarQ__"